import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false

Vue.filter('dateMonthYear', date => {
  const formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    const options = {
      day: 'numeric',
      month: 'numeric',
      year: 'numeric',
      timeZone: 'UTC'
    };
    return formattedDate.toLocaleString('pt-BR', options);
  } else {
    return 'Data inválida';
  }
})

Vue.filter('dateTime', date => {
  const formattedDate = new Date(date);
  if (formattedDate instanceof Date && !isNaN(formattedDate)) {
    return formattedDate.toLocaleString('pt-BR');
  } else {
    return 'Data inválida';
  }
})

Vue.filter('price', price => {
  price = String(price).replace(',', '.');
  price = Number(price);
  if (!isNaN(price)) {
    return price.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    })
  } else {
    return ''
  }
})

// Carrega as configurações do sistema salvas no localStorage
// store.dispatch('loadConfiguracoes');

const token = sessionStorage.getItem('@ServicesSyclus:token') && JSON.parse(sessionStorage.getItem('@ServicesSyclus:token'))
const tokens = localStorage.getItem('@ServicesSyclus:tokens') && JSON.parse(localStorage.getItem('@ServicesSyclus:tokens'))
const licencas = localStorage.getItem('@ServicesSyclus:licencas') && JSON.parse(localStorage.getItem('@ServicesSyclus:licencas'))

if (token) {
  store.commit('SET_USUARIO_TOKENS', tokens)
  store.commit('SET_USUARIO_LICENCAS', licencas)
  store.dispatch('silentRefresh', token.refresh_token)
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })
} else if (tokens && tokens.length) {
  const [token] = tokens
  
  store.commit('SET_USUARIO_TOKENS', tokens)
  store.commit('SET_USUARIO_LICENCAS', licencas)
  store.dispatch('silentRefresh', token.refresh_token)
    .then(() => {
      new Vue({
        router,
        store,
        vuetify,
        render: h => h(App)
      }).$mount('#app')
    })
} else {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}